import { createApp } from 'vue';
import PngToAvifConverter from '../Components/PngToAvifConverter.vue';

const root = document.getElementById('png-to-avif-converter');
if (root) {
  createApp(PngToAvifConverter).mount('#png-to-avif-converter');
}
